<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Условие оплаты</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <button type="button" @click="sortPosition" class="btn btn-white btn-icon-text my-2 mr-2">
            <i class="ti-exchange-vertical mr-1"></i> Сортировать
          </button>
          <router-link to="/payment-method/add" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Добавить метод оплаты
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Список условие оплаты</h6>
            </div>
            <div class="table-responsive">
              <b-table striped hover :items="paymentMethods" :fields="paymentMethodFields">
                <template #cell(footer_image)="row">
                  <img v-if="row.item.footer_image" class="img-thumbnail table-image" :src="row.item.footer_image" alt="image">
                </template>
                <template #cell(page_image)="row">
                  <img v-if="row.item.page_image" class="img-thumbnail table-image" :src="row.item.page_image" alt="image">
                </template>
                <template #cell(sort)="row">
                  <input type="number" min="0" style="width: 100px" v-model="row.item.sort">
                </template>
                <template #cell(status)="row">
                  <span class="badge text-white" :class="{'bg-success': row.item.status === 'active', 'bg-danger': row.item.status !== 'active'}">{{row.item.status}}</span>
                </template>
                <template #cell(actions)="row">
                  <router-link :to="`/payment-method/${row.item.id}`" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                    <i class="fe fe-edit"></i>
                  </router-link>
                  <button v-if="row.item.status === 'active'" @click="removePaymentMethod(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                    <i class="ti-close"></i>
                  </button>
                  <div v-else class="d-inline-block">
                    <button @click="restorePaymentMethod(row.item.id)" type="button" class="btn btn-outline-success mr-2 mt-1 mb-1">
                      <i class="fe fe-rotate-ccw"></i>
                    </button>
                    <button @click="removePaymentMethod(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                      <i class="fe fe-trash-2"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <div class="d-flex justify-content-end  mt-3">
                <div class="mr-3">
                  <b-form-select
                    @change="changePaginationPerPage"
                    style="width: 80px"
                    v-model="paginationPerPage"
                    :options="paginationOptions"
                  >
                  </b-form-select>
                </div>
                <div>
                  <b-pagination
                    class="m-0"
                    @change="changePagination"
                    v-model="paginationCurrentPage"
                    :total-rows="pagination.count"
                    :per-page="paginationPerPage"
                    first-text="<<"
                    prev-text="<"
                    next-text=">"
                    last-text=">>"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'PaymentMethod',
  data () {
    return {
      paginationOptions: [
        { value: 6, text: '6' },
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 100, text: '100' }
      ],
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      pagination: {}
    }
  },
  computed: {
    ...mapState({
      paymentMethods: state => state.paymentMethod.paymentMethods
    }),
    paymentMethodFields () {
      return [
        {
          key: 'id',
          sortable: true
        },
        {
          key: 'footer_image',
          label: 'Фото в подвале',
          sortable: true
        },
        {
          key: 'page_image',
          label: 'Фото на странице',
          sortable: true
        },
        {
          key: 'sort',
          label: 'Сортировка',
          sortable: true
        },
        {
          key: 'name.' + this.$i18n.locale,
          label: 'Название',
          sortable: true
        },
        {
          key: 'description.' + this.$i18n.locale,
          label: 'Описание',
          sortable: true
        },
        {
          key: 'status',
          label: 'Статус',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Действие',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getPaymentMethodsList({})
  },
  methods: {
    ...mapActions({
      getPaymentMethods: 'paymentMethod/getPaymentMethods',
      restore: 'paymentMethod/restore',
      deletePaymentMethod: 'paymentMethod/deletePaymentMethod',
      sortPositionPaymentMethod: 'paymentMethod/sortPositionPaymentMethod'
    }),
    getPaymentMethodsList (params) {
      this.getPaymentMethods(params).then(res => {
        this.pagination = res.pagination
      }).catch(() => {
        this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
      })
    },
    changePaginationPerPage (value) {
      this.getPaymentMethodsList({ page: this.paginationCurrentPage, count: value })
    },
    changePagination (page) {
      this.getPaymentMethodsList({ page: page, count: this.paginationPerPage })
    },
    removePaymentMethod (id) {
      Swal.fire({
        text: this.$t('messages.warning.delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.deletePaymentMethod(id).then(res => {
            this.$toasted.success(this.$t('messages.success.paymentMethodDeleted')).goAway(1500)
          }).catch(() => {
            this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
          })
        }
      })
    },
    restorePaymentMethod (id) {
      Swal.fire({
        text: this.$t('message.warning.restore'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.restore(id).then(res => {
            this.$toasted.success(this.$t('messages.success.paymentMethodDeleted')).goAway(1500)
          }).catch(() => {
            this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
          })
        }
      })
    },
    sortPosition () {
      const formData = { data: [] }
      for (let i = 0; i < this.paymentMethods.length; i++) {
        formData.data.push({ id: this.paymentMethods[i].id, sort: this.paymentMethods[i].sort })
      }
      this.sortPositionPaymentMethod({ data: formData }).then(res => {
        this.getPaymentMethodsList({ page: this.paginationCurrentPage, count: this.paginationPerPage })
        this.$toasted.success(res.data.data).goAway(1500)
      })
    }
  }
}
</script>
